var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckMarkIcon = function SvgCheckMarkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 87.5c24.024 0 43.5-19.476 43.5-43.5S68.024.5 44 .5.5 19.976.5 44 19.976 87.5 44 87.5Z",
    fill: "#4D9F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.269 61.93c-1.22 0-2.39-.49-3.26-1.35l-13.19-13.19a4.6 4.6 0 0 1 0-6.51 4.6 4.6 0 0 1 6.51 0l9.94 9.94 23.4-23.4a4.6 4.6 0 0 1 6.51 0 4.6 4.6 0 0 1 0 6.51l-26.65 26.66c-.86.86-2.03 1.35-3.26 1.35v-.01Z",
    fill: "#fff"
  })));
};
export default SvgCheckMarkIcon;